import { createNativeStackNavigator, NativeStackScreenProps } from '@react-navigation/native-stack';
import * as React from 'react';

import { CardAccountListScreen } from '@/features/card-account/screens/list/CardAccountList.screen';
import { CardListNativeScreen } from '@/features/card-account/screens/list/CardListNative.screen';
import {
  BottomSheetFilter as ListBottomSheetFilter,
  BottomSheetFilterProps as ListBottomSheetFilterProps
} from '@/features/card-account/screens/list/BottomSheetFilter';
import { AccountItem } from '@/features/card-account/hooks/useCardAccounts.hook';
import { CreateCardAccountNavigator } from '@/features/card-account/screens/create-card-account/createCardAccount.navigator';
import {
  BottomSheetDatePicker,
  BottomSheetDatePickerProps
} from '@/features/card-account/screens/bottomSheetDatePicker/BottomSheetDatePicker';
import { AccountManagementStackParamList, AccountManagementStackRoutes } from '@/features/account-management/account.navigator';
import { DownloadTransactionReportNavigator } from '@/features/account-management/screens/download-transaction-report/DownloadTransactionReport.navigator';
import {
  BottomSheetDatePicker as AccountBottomSheetDatePicker,
  BottomSheetDatePickerProps as AccountBottomSheetDatePickerProps
} from '@/features/account-management/screens/bottomSheetDatePicker/BottomSheetDatePicker';

export enum CardAccountStackRoutes {
  List = 'card-account-list',
  CardDetails = 'card-account-details',
  ListBottomSheetFilter = 'card-account-list-bottom-sheet-filter',
  CreateCardAccount = 'card-account-create-card-account',
  BottomSheetDatePicker = 'buttom-sheet-date-picker'
}

export type CardAccountStackParamList = {
  [CardAccountStackRoutes.List]: undefined;
  [CardAccountStackRoutes.CardDetails]: { record: AccountItem };
  [CardAccountStackRoutes.ListBottomSheetFilter]: ListBottomSheetFilterProps;
  [CardAccountStackRoutes.CreateCardAccount]: {
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    refresh?: () => void;
  };
  [CardAccountStackRoutes.BottomSheetDatePicker]: BottomSheetDatePickerProps;
  [AccountManagementStackRoutes.DownloadTransactionReport]: {
    walletId?: string;
    creditLineId?: string;
  };
  [AccountManagementStackRoutes.BottomSheetDatePicker]: AccountBottomSheetDatePickerProps;
};

export type CardAccountStackScreenProps<Screen extends keyof CardAccountStackParamList> = NativeStackScreenProps<
  CardAccountStackParamList,
  Screen
>;

const CardAccountStack = createNativeStackNavigator<CardAccountStackParamList>();
const AccountManagementStack = createNativeStackNavigator<AccountManagementStackParamList>();

export function CardAccountNavigator(): JSX.Element {
  return (
    <CardAccountStack.Navigator
      screenOptions={{
        headerShown: false
      }}
      initialRouteName={CardAccountStackRoutes.List}>
      <CardAccountStack.Screen name={CardAccountStackRoutes.List} component={CardAccountListScreen} />
      <CardAccountStack.Screen
        options={{
          presentation: 'modal',
          headerShown: false
        }}
        name={CardAccountStackRoutes.CardDetails}
        component={CardListNativeScreen}
      />
      <CardAccountStack.Screen
        name={CardAccountStackRoutes.ListBottomSheetFilter}
        component={ListBottomSheetFilter}
        options={{ presentation: 'transparentModal' }}
      />
      <CardAccountStack.Screen
        name={CardAccountStackRoutes.CreateCardAccount}
        component={CreateCardAccountNavigator}
        options={{ presentation: 'transparentModal' }}
      />
      <CardAccountStack.Screen
        name={CardAccountStackRoutes.BottomSheetDatePicker}
        component={BottomSheetDatePicker}
        options={{ presentation: 'transparentModal' }}
      />
      <AccountManagementStack.Screen
        name={AccountManagementStackRoutes.DownloadTransactionReport}
        component={DownloadTransactionReportNavigator}
        options={{ presentation: 'transparentModal' }}
      />
      <AccountManagementStack.Screen
        name={AccountManagementStackRoutes.BottomSheetDatePicker}
        component={AccountBottomSheetDatePicker}
        options={{ presentation: 'transparentModal' }}
      />
    </CardAccountStack.Navigator>
  );
}
